export default "__VITE_ASSET__dfad3601__"